export default "__VITE_ASSET__ZFoTAOp9__"